import { useEffect, useState } from 'react'
import { getBPDataWithoutParams } from 'src/business/services'
import { CHeading5 } from 'src/components/coreUIMimicComponent'
import { MoreGoalsContainer } from './styledComponents'
import { mediaURL } from 'src/consumer/services'

export default function AllGoals({ existingGoals, ...props }) {
  const [allGoals, setAllGoals] = useState([{}])

  const getAndSetAllGoals = async () => {
    const response = await getBPDataWithoutParams('/api/secure/bc/goals/all')
    if (response?.status === 200) {
      setAllGoals(
        response?.data?.filter((goal) => !existingGoals.some((element) => element.id === goal.id)),
      )
    }
  }

  useEffect(() => {
    getAndSetAllGoals()
  }, [existingGoals])

  return (
    <>
      {!allGoals[0] ? (
        <span className="dark:text-white">No more goals available</span>
      ) : (
        allGoals.map((item) => {
          return (
            <div
              onClick={() => {
                props.setDesc(item)
              }}
              key={item.id}
            >
              <MoreGoalsContainer>
                <div
                 className="w-72 h-48 mx-auto d-flex flex-wrap  rounded-4 overflow-hidden"
                  onClick={props.handleClick}
                  style={{ position: 'relative', backgroundImage: `url(${mediaURL}${item.coverIcon})`,backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  width: '200px',
                  height: '200px',
                  }}
                 > 
                  
                  <div
                  
                    className="position-absolute w-100 h-100 rounded-top-2xl pt-3"
                    style={{
                      background: 'rgba(0, 0, 0, 0.5)',
                    }}
                  >
                    
                  </div>
                  <CHeading5 className="position-relative p-4 font-weight-bold text-white overflow-hidden">{item.name}</CHeading5>
                </div>
                <div
                  onClick={() =>
                    props.check(
                      props?.selectedId?.find((selId) => item?.id === selId) ? false : true,
                      item.id,
                    )
                  }
                  style={{ cursor: 'pointer' }}
                  className="w-100 rounded-4 pt-3"
                >
                  {!props?.selectedId?.find((selId) => item?.id === selId) ? (
                    <div className="bg-success text-white text-center font-weight-bold w-100 rounded-bottom-2x p-2 rounded-4 ">
                      Add this goal +
                    </div>
                  ) : (
                    <div className="bg-danger text-white text-center font-weight-bold w-100 rounded-bottom-2xl p-2 rounded-4">
                      Remove this goal -
                    </div>
                  )}
                </div>
              </MoreGoalsContainer>
            </div>
          )
        })
      )}
    </>
  )
}